@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (pastTransactions.length === 0 && !loading) {
  <mat-card>
    <mat-card-content>
      <div class="empty-table">
        <mat-icon>info</mat-icon>
        <p>No past transactions found</p>
      </div>
    </mat-card-content>
  </mat-card>
}

@if (pastTransactions.length > 0 && !loading) {
  <div class="table-container">
    <table mat-table [dataSource]="pastTransactions" class="transactions-table">
      <!-- Transaction ID Column -->
      <ng-container matColumnDef="transaction_id">
        <th mat-header-cell *matHeaderCellDef>Transaction ID</th>
        <td mat-cell *matCellDef="let transaction">
          <a [routerLink]="['/', transactionDetailsLink, transaction.transaction_id]" class="button-link">
            {{ transaction.transaction_id }}
          </a>
        </td>
      </ng-container>
      <!-- Supplier Column -->
      <ng-container matColumnDef="supplier_company">
        <th mat-header-cell *matHeaderCellDef>Supplier</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.supplier_company }}</td>
      </ng-container>
      <!-- Buyer Company Column -->
      <ng-container matColumnDef="buyer_company">
        <th mat-header-cell *matHeaderCellDef>Buyer Company</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.buyer_company }}</td>
      </ng-container>
      <!-- Buyer ID Column -->
      <ng-container matColumnDef="buyer_id">
        <th mat-header-cell *matHeaderCellDef>Buyer ID</th>
        <td mat-cell *matCellDef="let transaction">{{ transaction.buyer_id }}</td>
      </ng-container>
      <!-- Last Update Date Column -->
      <ng-container matColumnDef="last_update_date">
        <th mat-header-cell *matHeaderCellDef>Last Update Date</th>
        <td mat-cell *matCellDef="let transaction">{{ formatDate(transaction.last_update_date) }}</td>
      </ng-container>
      <!-- Amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.amount) }}</td>
      </ng-container>
      <!-- Status Title Case Column -->
      <ng-container matColumnDef="statusTitleCase">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let transaction">
          <span class="status-badge status-green">
            Paid
          </span>
        </td>
      </ng-container>
      <!-- Current Balance Column -->
      <ng-container matColumnDef="current_balance">
        <th mat-header-cell *matHeaderCellDef>Current Balance</th>
        <td mat-cell *matCellDef="let transaction">{{ formatCurrency(transaction.current_balance) }}</td>
      </ng-container>
      <!-- Header and Row Declarations -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let transaction">
          <!-- @dev decision, @product removed table from UI and changed refund action to be handled in authorization
          <button mat-raised-button color="primary" (click)="refundTransaction(transaction)">
            Refund
          </button>
          -->
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="transaction-row"></tr>
    </table>
  </div>
}
